module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "ch2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#rch2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "href": "#/contents#rch2"
    }
  }, [_vm._v("My American Home")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcaps"
  }, [_vm._v("W")]), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEN")]), _vm._v(" I pulled into the driveway, my two-year-old daughter Serena was out in the front yard flailing at something with my fishing rod. She was holding the rod by the tip and slamming the reel down on the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Dada!” she cried. “Wiggle whack crawly bug!” Something moved in the grass, and Serena whipped my rod back for a real knockout punch. The fiberglass snapped, and the piece with the reel flew over to crash on my Buick’s shiny hood.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("I got out of the car and tried to just walk on past her. I was definitely ripe for my Friday-afternoon beer. But Serena was too fast for me. She put herself between me and the house.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Bad crawly bug!” She pointed with the tip of my broken rod. “Try bite Serena!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("I gave a heavy sigh and went over to look. Serena "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("was hell on insects. A badly mashed stag beetle was lying in the grass. I was relieved that it wasn’t a little Harry.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Where’s Mommy, Serena?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Mama lie down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Were you a good girl today?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Babby bite.” She held out her hand to show me a tiny cut on her forefinger.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“The neighbor’s baby bit you? What were you doing to it?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Playing. Babby bite. Mary Jo wash.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Mary Jo was the name of the woman next door. Serena liked to go over and pick on her baby. “Was Mary Jo mad at you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Mary Jo wash.” Serena showed me her finger again. The cut certainly did look clean.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“How nice of Mary Jo to wash your cut. I just hope her baby doesn’t have rabies.” I patted Serena on the head. She was a brat, but she was mine. “Would you like a candy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Yus.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Here.” I found a linty cough drop in my pants pocket. “Now don’t bother that baby any more. And put my fishing rod away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Bug gone.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“I’m going inside to see Mommy now, Serena. Be good.” I walked into our crummy house, still brooding over Harry’s message. There could be money in this, big money.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("I found Nancy flaked out on our double bed with a stack of old "), _c('i', [_vm._v("People")]), _vm._v(" magazines and an overflowing ashtray. The TV was going full blast in the other room. I closed the door.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("“God, Joey, I have such a backache today. And this morning Serena—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Yeah, I’ve had a rough day myself. Is there any beer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Do you think you could rub my back a little?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“If you move the ashtray. You know I don’t like you to smoke in our bedroom.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Then why don’t you buy a couch for the living room. I hate living like this. We might as well be in a trailer park.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("When we’d first married, we’d had a much nicer home. But I’d lost it when Fletcher & Company went bankrupt. The house we rented now was a low-ceilinged three-room tract home: two bedrooms and a kitchen-dining-living room. Looking out the bedroom window, I could see fifty-three houses exactly like ours (one Sunday afternoon I’d counted them). Our development was a reclaimed marsh with woods all around it.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“I’m going to go see Harry tomorrow. I think he’s invented something new.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Don’t give him any money, Joseph. I mean it. We need that money for our Christmas trip.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“What trip?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Don’t you ever listen to anything I tell you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Look, I’m going to get a beer. You want one?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“How about my back rub?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Nancy was lying on her stomach. I sat on the backs of her legs and worked my fingers up and down her spine. She felt small and fragile, and she gave off a good smell. My woman.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“I’m sorry to complain so much, Joey. At least we have enough to eat. There’s another terrible famine going on in Mexico, did you know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("Nancy had some strange complexes about food. She was into world hunger, often serving on committees and raising funds. Yet she herself ate very immoderately. Somehow she never seemed to gain weight.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“No, I didn’t know that. This afternoon, when I went out to the Buick in the lot, something really—”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Someone was trying to open the bedroom door. Serena.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Just a minute, sweetie! Does that feel better, Nancy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“A little. Could you do something with Serena? She’s been just awful. This morning she went next door and stuck her hand in the baby’s mouth. That baby only has one tooth, but it bit Serena and she threw a fit. Mary Jo had to carry her back here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“What a brat.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Oh, but be nice to her. I was just like Serena when I was little.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Unable to turn the knob, Serena began kicking the door. “Dada! Dada! Dada! Dada!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Here I come. Don’t break the door.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("When I opened the door, Serena squealed and toddled off at high speed. I followed her into the kitchen and popped the top on a Bud. One thing about Nancy, she kept the fridge well-stocked. I inhaled the first beer and started a second. That regress had been bad news. In a way it had taken place outside of time. I wondered what would have happened if I’d wrung the neck of the thumb-sized Fletcher in the toy car. The giant would have done the same to me, of course, while being choked himself and uh uh uh. Hall of mirrors. Harry’s "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("doing. Master of space and time. I’d ask him for five million.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("I got out the phone book and looked under "), _c('i', [_vm._v("Appliances, Service and Repair")]), _vm._v(". Harry had taken over his family’s business when his parents died last winter. I’d never seen the place yet. The ad was pure Harry:")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', [_c('b', [_vm._v("Don’t Think We Don’t Think Don’t"), _c('br'), _vm._v("Think Don’t"), _c('br'), _vm._v("Robotics and Appliance Repair"), _c('br'), _vm._v("GERBER CYBERNETICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('span', [_c('b', [_vm._v("Twenty Years at the Same Location!"), _c('br'), _vm._v("Yes, We Take Cash!"), _c('br'), _vm._v("824-1301     501 Suydam St."), _c('br'), _vm._v("New Brunswick")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_c('i', [_vm._v("Cybernetics")]), _vm._v(". That was a word Harry and I had always laughed about. Nobody has any idea what it means, it’s just some crazy term that Norbert Wiener made up. Gerber Cybernetics. I dialed the number.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Hello?” An old woman’s questioning quaver.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“This is Joseph Fletcher. Is Mr. Gerber in?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“I’ll get him. "), _c('i', [_vm._v("Haaaaaaaaryr!")]), _vm._v("” There were footsteps, the sound of breaking glass, a curse, some yelling. The person at the other end knocked the phone off the counter, then picked it up.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Hello?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Harry! What do you have?” I lowered my voice "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("so that Nancy wouldn’t hear me. “I can spare two grand, but no more.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Who’s this?” He sounded confused. In the background the old-woman-voice was still yelling.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_c('i', [_vm._v("“Who’s this")]), _vm._v(". Who do you think it is, space cadet?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Is this Joe Fletcher?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“I’m supposed to come tomorrow, right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“We’re open ten to five on Saturdays.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“I’ll come in early and we can have lunch together. Like real businessmen. Do you have any circuit diagrams for the thing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“You want me to invent something?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“I thought you already had it. "), _c('i', [_vm._v("Master of Space and Time")]), _vm._v(", right?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“I don’t know what you’re talking about, Fletch. Are you drunk?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("This was getting nowhere fast. If the little Harrys had been from the future, then maybe he really "), _c('i', [_vm._v("didn’t")]), _vm._v(" know what I was talking about. “You’re going to be master of space and time,” I explained. “I want five million dollars.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Hold on.” There were voices in the background. “Yes, it’s ready, ma’am. Fletcher, I’m going to have to hang up. Customers. See you tomorrow!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Serena had climbed onto my lap while I was talking. She was about as short as you can be and still walk. I planted a kiss on her fat little cheek. “You’re not really a brat, are you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("“Dada hand.” She starfished her little paw against my palm. “Serena hand!”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("I looked around our shabby living area. Everything plastic, piles of laundry, and the TV always on. I wished I’d bought some good furniture when I’d had the money. Nancy and Serena deserved better than this.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-787dcaca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter002.vue
// module id = 78
// module chunks = 0